import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950">视频分类</h2>
          <Link
            to="/category/tv-series"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line align-middle"></i>
          </Link>
        </div>
        <div className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-8 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-200 group cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors duration-200">
                <i className={`${cat.icon} text-lg md:text-xl text-primary-600`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count.toLocaleString()}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}